// base
import React from 'react';

// style
import { StyledTbmStatusChart } from './style';

// modules
import { UserCountByDiscipline } from 'modules/tbm';

// libraries
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { max } from 'lodash-es';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

interface TbmStatusChartProps {
  chartData: UserCountByDiscipline[];
}

export const TbmStatusChart: React.FC<TbmStatusChartProps> = ({ chartData }) => {
  const labels = chartData.map((data) => data.discipline.cdNm);
  const completed = chartData.map((data) => data.completed);
  const working = chartData.map((data) => data.working);

  const data = {
    labels,
    datasets: [
      {
        label: 'Completed',
        data: completed,
        backgroundColor: '#9E9E9E',
        stack: 'Stack 0'
      },
      {
        label: 'Working',
        data: working,
        backgroundColor: '#3f51b5',
        stack: 'Stack 0'
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        stacked: true,
        grid: {
          display: false,
          drawBorder: false
        }
      },
      y: {
        stacked: true,
        beginAtZero: true,
        grid: {
          display: false,
          drawBorder: false
        },
        position: 'right',
        suggestedMax: max(completed) || 0 + 3,
        ticks: {
          stepSize: 1
        }
      }
    },
    plugins: {
      legend: {
        display: false
      }
    },

    elements: {
      bar: {
        borderRadius: 4,
        barPercentage: 0.8,
        categoryPercentage: 0.8
      }
    }
  };
  return (
    <StyledTbmStatusChart>
      <Bar options={options} data={data} />
    </StyledTbmStatusChart>
  );
};
